module.exports = __webpack_public_path__ + "media/images/front/equipment/h1_device-a91e9f96865ab8bf96138fefd2ac36d3.svg";